export default __webpack_public_path__ + "static/media/face-6.b75146da.jpeg";